import React from 'react';
import { Lightbulb } from 'lucide-react';
import { SmartSuggestions } from '../components/SmartSuggestions';

export const SmartSuggestionsLab: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="text-center space-y-2">
        <div className="flex items-center justify-center gap-3">
          <Lightbulb className="h-8 w-8 text-[var(--mustard)]" />
          <h1 className="text-3xl font-bold text-charcoal-900">Smart Suggestions (Lab)</h1>
        </div>
        <p className="text-charcoal-600 text-sm">Experimental suggestion engine surfaced from the M2 template (v1).</p>
      </div>

      <div className="bg-[var(--bg-raised)] border border-charcoal-200 p-4">
        <SmartSuggestions />
      </div>
    </div>
  );
};


